import React from "react";
import AnimatedValue from "./AnimatedValue";

interface Props {
  variation: string;
  capitalGain: string;
}

const variationColor = (v: string) => {
  // Normaliza guiones Unicode (−) a ASCII (-) antes de parsear
  const n = parseFloat(v.replace(/[−–]/g, "-"));
  if (n > 0) return "text-emerald-500";
  if (n < 0) return "text-red";
  return "text-gray-900";
};

const ZoneMetrics: React.FC<Props> = ({ variation, capitalGain }) => (
  <div className="grid grid-cols-2 gap-2 md:gap-3 mb-3 md:mb-6">
    <div className="bg-gray-100 rounded-xl p-3 md:p-4">
      <p className="text-sm md:text-base text-gray-500">Variación 6 meses</p>
      <p className={`text-lg font-bold ${variationColor(variation)}`}><AnimatedValue value={variation} /></p>
    </div>
    <div className="bg-gray-100 rounded-xl p-3 md:p-4">
      <p className="text-sm md:text-base text-gray-500">Plusvalía</p>
      <p className="text-lg font-bold text-gray-900">{capitalGain}</p>
    </div>
  </div>
);

export default ZoneMetrics;
